import React from 'react';
import { useStyles } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { VIEWER_HOOKS } from '../../../../../constants';
import { useAdaptedSettings, useStylesParams } from '../../../../../hooks';
import { st, classes } from './PlanName.st.css';

interface Props {
  name: string;
  highlighted: boolean;
}

export const PlanName: React.FC<Props> = ({ name, highlighted }) => {
  const { isMobile } = useEnvironment();
  const stylesParams = useStylesParams();
  const styles = useStyles();
  const settings = useAdaptedSettings();
  const showPlanName = styles.get(stylesParams.showPlanName);
  const PlanNameTitleTag = settings.get('planTitleHtmlTag') as keyof JSX.IntrinsicElements;

  if (!showPlanName) {
    return null;
  }

  return (
    <PlanNameTitleTag
      data-hook={VIEWER_HOOKS.PLAN_NAME}
      aria-describedby={highlighted ? 'ribbon' : undefined}
      className={st(classes.planTitle, { highlighted, mobile: isMobile })}
    >
      {name}
    </PlanNameTitleTag>
  );
};
